import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-content" }
const _hoisted_2 = { class: "export-content__title-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "export-content__title" }, "Export", -1)
const _hoisted_4 = { class: "export-content__settings" }
const _hoisted_5 = { class: "export-content__integration-settings" }
const _hoisted_6 = { class: "export-content__buttons-wrapper" }
const _hoisted_7 = { class: "export-content__setting_buttons" }

import { ref } from 'vue'

import ReadwiseSettings from '@/app/components/export/ReadwiseSettings.vue'
import NotionSettings from '@/app/components/export/NotionSettings.vue'
import IntegrationButton from '@/app/components/export/IntegrationButton.vue'

import readwiseLogo from '@/assets.v2/images/readwise-logo.svg'
import readwiseLogoDark from '@/assets.v2/images/readwise-logo-dark.svg'
import notionLogo from '@/assets.v2/images/notion-logo.svg'
import notionLogoDark from '@/assets.v2/images/notion-logo-dark.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportSettings',
  setup(__props) {

const selectedIntegration = ref<string | null>(null)
const isReadwiseEnabled = ref(false)
const isNotionEnabled = ref(false)

function clickIntegrationButton(integration: string): void {
  selectedIntegration.value = integration
}

function setReadwiseEnabled(value: boolean): void {
  isReadwiseEnabled.value = value
}

function setNotionEnabled(value: boolean): void {
  isNotionEnabled.value = value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(IntegrationButton, {
                name: "readwise",
                description: "Resurfacing your best highlights",
                isSelected: selectedIntegration.value === 'Readwise',
                imageUrl: _unref(readwiseLogo),
                darkImageUrl: _unref(readwiseLogoDark),
                isEnabled: isReadwiseEnabled.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (clickIntegrationButton('Readwise')))
              }, null, 8, ["isSelected", "imageUrl", "darkImageUrl", "isEnabled"]),
              _createVNode(IntegrationButton, {
                name: "notion",
                description: "Workspace that adapts to your needs",
                imageUrl: _unref(notionLogo),
                darkImageUrl: _unref(notionLogoDark),
                isEnabled: isNotionEnabled.value,
                isSelected: selectedIntegration.value === 'Notion',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (clickIntegrationButton('Notion')))
              }, null, 8, ["imageUrl", "darkImageUrl", "isEnabled", "isSelected"])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(ReadwiseSettings, {
      isReadwiseEnabled: isReadwiseEnabled.value,
      onUpdateEnabled: setReadwiseEnabled
    }, null, 8, ["isReadwiseEnabled"]), [
      [_vShow, selectedIntegration.value === 'Readwise']
    ]),
    _withDirectives(_createVNode(NotionSettings, {
      isNotionEnabled: isNotionEnabled.value,
      onUpdateEnabled: setNotionEnabled
    }, null, 8, ["isNotionEnabled"]), [
      [_vShow, selectedIntegration.value === 'Notion']
    ])
  ]))
}
}

})